import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Stack, Grid, Paper, Button } from '@mui/material';

import CollectionsList from './CollectionsList';
import CollectionsEmptyCreate from './CollectionsEmptyCreate';
import FetchError from '../UI/fetch-error/FetchError';
import Loader from '../UI/loader/Loader';
import TextField from '../text-field/TextField';

import {
  useGetAuthenticationQuery,
  useGetCollectionsQuery,
} from '../../services/ADapi';

const Collections = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const {
    data: collections = [],
    isLoading,
    isError,
  } = useGetCollectionsQuery(user_id);

  const searchHandler = (e) => {
    setSearchQuery(e.target.value);
  };

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <FetchError />;
  }

  return (
    <Paper>
      {collections.length ? (
        <>
          <Stack
            gap={2}
            direction={{ xs: 'column', md: 'row' }}
            justifyContent={{ md: 'space-between' }}
            alignItems={{ md: 'flex-end' }}
          >
            <Grid item md={4}>
              <TextField
                id="search-field"
                value={searchQuery}
                label="Search"
                size="small"
                placeholder="Collection"
                onChange={searchHandler}
              />
            </Grid>
            <Grid item>
              <Button
                to="/collections/create"
                variant="contained"
                size="small"
                component={NavLink}
              >
                New Collection
              </Button>
            </Grid>
          </Stack>
          <CollectionsList searchQuery={searchQuery} />
        </>
      ) : (
        <CollectionsEmptyCreate />
      )}
    </Paper>
  );
};

export default Collections;
